<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-grid`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 6a1 1 0 011 1v34a1 1 0 01-1 1H6a1 1 0 01-1-1V7a1 1 0 011-1h2zm11 0a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2zm11 0a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2zm11 0a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconGrid',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
